module.exports = __webpack_public_path__ + "static/media/trophy-new-2.c9139b72.png";